<template>
  <div class="popup">
    <div class="popup__overlay" @click="closeModal"></div>
    <div class="popup__inner">
      <div class="popup__inner__details">
       <div class="teamInfo">
         <div class="teamInfo__img" :style="`background-image:url(${popupData.image})`">

         </div>
         <div class="teamInfo__content">
              <label>
                Name
              </label>
              <p>
                {{popupData.fullname}}
              </p>
              <label>
                Position
              </label>
              <p>
                {{popupData.position}}
              </p>
               
              <label v-if="popupData.info">
                Executive Bio
              </label>
              <p v-if="popupData.info" v-html="popupData.info">
              </p>
              <label>
              Links
              </label>
              <p class="linkedInIcon">
                  <a v-if="popupData.linkedin":href="popupData.linkedin">
                  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"><path d="M0 0v24h24v-24h-24zm8 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.397-2.586 7-2.777 7 2.476v6.759z"/></svg>

                  </a>
                   <a v-if="popupData.email" :href="'mailto:' + popupData.email">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="18.9px"
                          height="14.1px" viewBox="0 0 18.9 14.1" style="enable-background:new 0 0 18.9 14.1;" xml:space="preserve">
                        <defs>
                        </defs>
                        <g>
                          <path d="M0,12.6C0,9.8,0,6.9,0,4c0,0,0.1,0,0.1,0c2.6,1.7,5.1,3.4,7.7,5.1c1.1,0.7,2.3,0.7,3.4,0c2.5-1.7,5-3.4,7.6-5
                            c0.1,0,0.1-0.1,0.2-0.1c0,0.1,0,0.1,0,0.2c0,2.8,0,5.5,0,8.3c0,0.2,0,0.3-0.1,0.5c-0.2,0.8-0.9,1.3-1.8,1.3c-2.5,0-5,0-7.5,0
                            c-2.6,0-5.1,0-7.7,0c-0.5,0-0.9-0.1-1.3-0.5C0.2,13.4,0.1,13,0,12.6z"/>
                          <path d="M0,1.5c0-0.1,0.1-0.2,0.1-0.3C0.3,0.5,1,0,1.8,0c0.4,0,0.7,0,1.1,0C7.6,0,12.3,0,17,0c0.5,0,1,0.2,1.4,0.6
                            c0.7,0.8,0.6,2-0.3,2.5c-1.1,0.8-2.3,1.5-3.5,2.3c-1.4,0.9-2.7,1.8-4.1,2.7c-0.8,0.5-1.4,0.5-2.2,0C5.9,6.6,3.5,4.9,1.1,3.3
                            C0.5,3,0.1,2.6,0,2C0,1.8,0,1.7,0,1.5z"/>
                        </g>
                        </svg>


                  </a>
              </p>
              

         </div>

         </div>
       
      </div>
      <div class="popup__footer">
      
      </div>
      <div class="popup__inner__close" @click="closeModal()">
        <i class="popup__inner__close__icon"></i>
      </div>

    </div>


  </div>
</template>

<script>
  export default {
    name: 'popup',
    data() {
      return {
      
      };
    },
 
    props: {
      popupData: {},
    },
    created() {
    },
    methods: {
      closeModal(){
        this.$parent.closePopup();
      }
    },
    mounted(){
    },
  }
</script>

<style lang="scss" scoped>
  @import './style.scss';

  
.teamInfo {
    display: flex;
    min-height: 281px;
}

.teamInfo__img {
    flex: 1;
    background-position: center;
    background-size: cover;
    max-height: 332px;
}

.teamInfo__content {
    flex: 2;
    padding-left: 52px ;
}

@media screen and (max-width:768px) {
  .teamInfo {
    flex-direction: column;
  }
  .teamInfo__img {
      min-height: 312px;
      max-width: 312px;
      margin: auto;
      display: block;
      width: 100%;
      margin-bottom: 35px !important;
  }

  .teamInfo {
      align-content: center;
      align-items: center;
  }

  .teamInfo__content {
      padding-left: 0;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/About/popup/index.vue